// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1AesJ","footer":"ChangeClinic_footer__3EGnO"};